export default __webpack_public_path__ + "static/media/9efae8bd_2.28d53c38.png";